import { Professional } from '@interface/clinic';

/**
 * Nombre sin el "Dr."/"Dra." con el que algunos vienen de Flowww
 * ("Dra. Rosa Isabel"): la web ya antepone `tittleAbbreviation`.
 */
export function withoutTitle(name: string): string {
  return (name || '').replace(/^\s*dra?\.?\s+/i, '').trim();
}

/** "Dra. Nombre Apellido", sin repetir el título si ya viene en el nombre. */
export function doctorDisplayName(
  professional: Pick<Professional, 'tittleAbbreviation' | 'name'>
): string {
  return `${professional.tittleAbbreviation || 'Dr'}. ${withoutTitle(
    professional.name
  )}`;
}
